module.exports = __webpack_public_path__ + "static/img/result_ceil.2d14bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ceil.jpg
// module id = xcsS
// module chunks = 3